export const GA = {
    translations: {
        notifications: 'Fógraí',
        markAllAsRead: 'Marcáil go léir mar a léitear',
        poweredBy: 'Cumhachtaithe ag',
        settings: 'Socruithe',
        noNewNotification: 'Níl aon rud nua le feiceáil anseo fós',
    },
    lang: 'ga',
};
//# sourceMappingURL=ga.js.map